// Mock data for Dr. Lim Siow Jin website

export const mockData = {
  hero: {
    name: "Datuk Dr. Lim Siow Jin",
    title: "Visionary Entrepreneur | Zen Master | Wellness Pioneer",
    subtitle: "Integrating Business Excellence, Natural Wellness & Spiritual Wisdom for Global Transformation",
    image: "https://www.dxn2u.com/founder/images/Datuk-Lim.jpg",
    cta: [
      { text: "Explore Sunya Meditation", link: "/sunya" },
      { text: "Learn About DXN", link: "/dxn" }
    ]
  },
  
  stats: [
    { number: "30+", label: "Years Business Journey" },
    { number: "180+", label: "Countries Worldwide" },
    { number: "15-20M", label: "Global Distributors" },
    { number: "RM1.6B+", label: "Revenue (FY2023)" },
    { number: "100+", label: "Educational Talks" },
    { number: "7", label: "Sunya Belt Levels" }
  ],
  
  pillars: [
    {
      id: 1,
      title: "Business & Prosperity",
      subtitle: "DXN Holdings Bhd",
      description: "Founder & Executive Chairman of DXN Holdings Bhd, operating in 180+ countries with 15-20 million distributors. Pioneer of vertical integration 'One Dragon' concept - from organic cultivation to global distribution.",
      image: "https://images.unsplash.com/photo-1524661135-423995f22d0b",
      icon: "TrendingUp",
      link: "/dxn",
      highlights: [
        "RM1.6 Billion Revenue (FY2023)",
        "180+ Countries Global Presence",
        "15-20 Million Distributors",
        "GMP & ISO Certified Facilities"
      ]
    },
    {
      id: 2,
      title: "Wellness & Health",
      subtitle: "Ganotherapy & TCM",
      description: "20+ years of Ganoderma research and Ganotherapy development. Master of Traditional Chinese Medicine, specializing in Shang Han Lun teachings and herbal medicine integration for modern wellness.",
      image: "https://images.unsplash.com/photo-1630623081968-3d73bc9b39ff",
      icon: "Heart",
      link: "/ganotherapy",
      highlights: [
        "20+ Years Ganoderma Research",
        "Traditional Chinese Medicine Expert",
        "Shang Han Lun Master Teacher",
        "Natural Healing Pioneer"
      ]
    },
    {
      id: 3,
      title: "Peace & Spirituality",
      subtitle: "Sunya Meditation & Sunyatee Foundation",
      description: "Founder of Sunyatee International Foundation and pioneer of Sunya Samatha Vipasyana meditation practice. A universal, non-religious path to inner peace and transformation accessible to all.",
      image: "https://images.unsplash.com/photo-1570276095143-a627b6514b1d",
      icon: "Leaf",
      link: "/sunya",
      highlights: [
        "Non-Religious Universal Practice",
        "7-Belt Progressive System",
        "Global Retreat Programs",
        "Ancient Wisdom for Modern Life"
      ]
    }
  ],
  
  latestTalks: [
    {
      id: 1,
      title: "What is Sunya?",
      category: "Sunya Talks",
      duration: "15:30",
      date: "2020-12-13",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/12-2.png",
      videoId: "sBme-38TjIU",
      videoType: "youtube",
      description: "Sunya originates from the Sanskrit word 'Sunyata' which means emptiness. From practicing Sunya, you get nothing in return.",
      views: "25.3K",
      featured: true,
      sourceUrl: "https://drlimsiowjin.com/episode/201213-sunya-talk-what-is-sunya/"
    },
    {
      id: 2,
      title: "Reverse Counting Meditation",
      category: "Sunya Talks",
      duration: "13:17",
      date: "2020-07-24",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/1-2.png",
      videoId: "719094782212264",
      videoType: "facebook",
      description: "Just like various things in life, reverse counting requires regular practice. Once you master this technique, you will reap the benefits in the form of serenity and peace.",
      views: "18.2K",
      featured: true,
      sourceUrl: "https://drlimsiowjin.com/episode/200724-sunya-talk-reverse-counting/"
    },
    {
      id: 3,
      title: "What Is Happiness?",
      category: "Sunya Talks",
      duration: "14:45",
      date: "2020-07-31",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/2-7.png",
      videoId: "sunyatalk-happiness",
      videoType: "facebook",
      description: "Exploring the nature of true happiness through the lens of Sunya meditation practice.",
      views: "12.8K",
      sourceUrl: "https://drlimsiowjin.com/episode/200731-sunyatalk-what-is-happiness/"
    },
    {
      id: 4,
      title: "The Right Practice",
      category: "Sunya Talks",
      duration: "16:20",
      date: "2020-08-14",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/3-5.png",
      videoId: "sunyatalk-right-practice",
      videoType: "facebook",
      description: "Understanding the correct approach to Sunya meditation for maximum benefit.",
      views: "10.5K",
      sourceUrl: "https://drlimsiowjin.com/episode/200814-sunya-talk-the-right-practice/"
    },
    {
      id: 5,
      title: "Let's Talk About Herbs",
      category: "Herbal Talk",
      duration: "22:15",
      date: "2020-04-20",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/1-3.png",
      videoId: "herbal-talk-ch1",
      videoType: "facebook",
      description: "Introduction to herbal medicine and the foundations of natural healing.",
      views: "15.1K",
      sourceUrl: "https://drlimsiowjin.com/episode/200420-herbal-talk-chapter-1-lets-talk-about-herbs/"
    },
    {
      id: 6,
      title: "How to Become a Good Ganotherapist",
      category: "Ganotherapy",
      duration: "19:30",
      date: "2020-05-06",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/3.png",
      videoId: "ganotherapy-good",
      videoType: "facebook",
      description: "The training and principles required to become an effective Ganotherapist.",
      views: "21.4K",
      sourceUrl: "https://drlimsiowjin.com/episode/200506-how-to-become-a-good-ganotherapist/"
    },
    {
      id: 7,
      title: "Author and Background of Shang Han Lun",
      category: "Shang Han Lun",
      duration: "25:40",
      date: "2020-12-17",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/12.png",
      videoId: "shl-author",
      videoType: "facebook",
      description: "Exploring the history and author of the classical Shang Han Lun text.",
      views: "8.9K",
      sourceUrl: "https://drlimsiowjin.com/episode/201217shl-s102-author-and-background-of-shang-han-lun/"
    },
    {
      id: 8,
      title: "Coffee Talk: The Training in Future",
      category: "Coffee Talks",
      duration: "18:10",
      date: "2020-11-23",
      thumbnail: "https://drlimsiowjin.com/wp-content/uploads/2021/03/5.png",
      videoId: "coffee-talk-future",
      videoType: "facebook",
      description: "Discussing the future of wellness training and education.",
      views: "11.2K",
      sourceUrl: "https://drlimsiowjin.com/episode/201123-coffee-talk-the-training-in-future/"
    }
  ],
  
  // Talk series based on drlimsiowjin.com categories
  talkSeries: [
    {
      id: "sunya-talks",
      title: "Sunya Talks",
      description: "Explore the fundamental teachings of Sunya meditation and the path to inner peace",
      thumbnail: "https://images.unsplash.com/photo-1570276095143-a627b6514b1d",
      videoCount: 25,
      category: "Meditation & Spirituality"
    },
    {
      id: "ganotherapy",
      title: "Ganotherapy",
      description: "Discover the healing power of Ganoderma Lucidum and its applications in modern wellness",
      thumbnail: "https://images.unsplash.com/photo-1630623081968-3d73bc9b39ff",
      videoCount: 18,
      category: "Health & Wellness"
    },
    {
      id: "shang-han-lun",
      title: "Shang Han Lun",
      description: "Classical Chinese medicine formulations and their modern applications",
      thumbnail: "https://images.unsplash.com/photo-1545840716-c82e9eec6930",
      videoCount: 12,
      category: "Traditional Medicine"
    },
    {
      id: "herbal-talk",
      title: "Herbal Talk",
      description: "Traditional herbal medicine and natural healing approaches",
      thumbnail: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528",
      videoCount: 15,
      category: "Herbology"
    },
    {
      id: "coffee-talks",
      title: "Coffee Talks",
      description: "Casual conversations about wellness, life philosophy, and personal development",
      thumbnail: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085",
      videoCount: 22,
      category: "Lifestyle & Philosophy"
    },
    {
      id: "hexageneous-reflexology",
      title: "Hexageneous Reflexology",
      description: "Unique reflexology techniques and pressure point therapy methods",
      thumbnail: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874",
      videoCount: 8,
      category: "Alternative Therapy"
    },
    {
      id: "herbology",
      title: "Herbology",
      description: "Comprehensive study of medicinal plants and their therapeutic properties",
      thumbnail: "https://images.unsplash.com/photo-1509453721491-c3af5961df76",
      videoCount: 10,
      category: "Plant Medicine"
    },
    {
      id: "charla-de-cafe",
      title: "Charla de Café",
      description: "Spanish language series discussing natural health and wellness philosophy",
      thumbnail: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df",
      videoCount: 6,
      category: "International"
    }
  ],
  
  articles: [
    {
      id: 1,
      title: "The Journey from Engineer to Zen Master",
      category: "Biography",
      excerpt: "From IIT Kharagpur to building a billion-dollar wellness empire while pursuing spiritual enlightenment...",
      date: "2024-01-12",
      readTime: "8 min",
      image: "https://www.dxn2u.com/founder/images/Datuk-Lim.jpg",
      author: "Dr. Lim Siow Jin"
    },
    {
      id: 2,
      title: "One Dragon, One World: The Philosophy of Integration",
      category: "Business Philosophy",
      excerpt: "Understanding the complete vertical integration that made DXN a global leader in wellness products...",
      date: "2024-01-08",
      readTime: "12 min",
      image: "https://images.unsplash.com/photo-1713098965471-d324f294a71d",
      author: "Dr. Lim Siow Jin"
    },
    {
      id: 3,
      title: "Maha Anapana Smrti: The Ancient Practice for Modern Times",
      category: "Sunya Practice",
      excerpt: "Exploring the 2500-year-old breathing meditation technique that forms the foundation of Sunya practice...",
      date: "2024-01-03",
      readTime: "10 min",
      image: "https://images.unsplash.com/photo-1542157565-4607d82cf417",
      author: "Dr. Lim Siow Jin"
    }
  ],
  
  awards: [
    { title: "Panglima Jasa Negara (PJN)", issuer: "16th Yang di-Pertuan Agong, Malaysia", year: "2019", type: "National Honor", description: "Grants title 'Datuk'" },
    { title: "Dato' Setia Diraja Kedah (DSDK)", issuer: "Sultan of Kedah, Malaysia", year: "2005", type: "State Honor" },
    { title: "Tokoh Kebajikan Negara", issuer: "National Welfare Figure Award, Malaysia", year: "2023", type: "National Honor" },
    { title: "DSM Award", issuer: "Yang Dipertua Negeri Melaka, Malaysia", year: "2002", type: "State Honor" },
    { title: "BKM Award", issuer: "Sultan of Kedah, Malaysia", year: "2001", type: "State Honor" },
    { title: "Top 10 Outstanding Chinese Youth", issuer: "Kedah State Youth Association", year: "2001", type: "Recognition" },
    { title: "Mother Teresa International Award", issuer: "Humanitarian Service", year: "2004", type: "International" },
    { title: "Albert Schweitzer Award", issuer: "Positive Life Foundation", year: "2002", type: "International", description: "Humanitarian Service" },
    { title: "Millennium Award", issuer: "International Association of Educators for World Peace", year: "2002", type: "International" },
    { title: "Physician of the New Millennium Award", issuer: "Alternative Medicines Research Institute, Canada", year: "2002", type: "Professional" },
    { title: "Tathagat International Excellence Award", issuer: "6th International Conference on Ayurved", year: "2012", type: "International" },
    { title: "Prominent Business Leader Award", issuer: "Business Excellence", year: "2010", type: "Business" },
    { title: "Brand Scientist of the Year", issuer: "Prime Minister of Pakistan", year: "2010", type: "International" },
    { title: "Global Quality Management Gold Badge", issuer: "Switzerland", year: "2007", type: "International" },
    { title: "Honorary Advisor of Peace Society Worldwide", issuer: "UN-affiliated global organization", year: "2010", type: "International", description: "Peace advocacy" },
    { title: "Award of Excellence For Service To Humanity", issuer: "Peace Society Worldwide", year: "2010", type: "International" },
    { title: "Academic Fellow with rank of Professor", issuer: "Academie Scientifique Internationale, Toulouse, France", year: "2010", type: "Academic" },
    { title: "28th International Award for Technology and Quality", issuer: "New Millennium Award", year: "2010", type: "International" },
    { title: "Certificate of Fellowship", issuer: "World Health, Environment and Peace Foundation", year: "2002", type: "Fellowship" },
    { title: "Senior Visiting Professor", issuer: "Open International University for Alternative Medicines", year: "2002", type: "Academic", description: "Natural Healing & Ganotherapy" }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Sunya Practitioner, Singapore",
      content: "Sunya meditation has transformed my life. The reverse counting technique is so simple yet incredibly powerful. I've found peace I never thought possible.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      rating: 5
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      role: "DXN Crown Ambassador, India",
      content: "Dr. Lim's One Dragon philosophy changed my perspective on business. It's not just about profit, it's about creating value and empowering people globally.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      rating: 5
    },
    {
      id: 3,
      name: "Maria Rodriguez",
      role: "Wellness Practitioner, Mexico",
      content: "Ganotherapy and Dr. Lim's teachings on Ganoderma have revolutionized my approach to natural healing. The research and quality are unmatched.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      rating: 5
    }
  ],
  
  sunyaBelts: [
    { level: 1, name: "Red Belt", color: "#DC2626", description: "Beginner level - Introduction to Sunya practice, basic reverse counting from 29 to 0, learning body posture and breath awareness" },
    { level: 2, name: "Orange Belt", color: "#EA580C", description: "Developing consistency in practice, understanding breath awareness, progressing to 99 to 0 counting, initial body-breath coordination" },
    { level: 3, name: "Yellow Belt", color: "#CA8A04", description: "Achieving stability in meditation, initial mind training, reducing distractions, establishing regular practice routine" },
    { level: 4, name: "Green Belt", color: "#16A34A", description: "Integration of body, breath, and mind training, Basic Samatha Vipasyana (BSV), deeper focus and concentration" },
    { level: 5, name: "Blue Belt", color: "#2563EB", description: "Advanced Samatha practice, deeper introspection and self-observation, consistent tranquil mind states" },
    { level: 6, name: "Indigo Belt", color: "#4F46E5", description: "Maha Samatha Vipasyana (MSV) - interacting with environment while maintaining mindfulness, performing duties with complete focus" },
    { level: 7, name: "Violet Belt", color: "#7C3AED", description: "Advanced practitioner - Path toward Arhant (one who can freely enter and leave this world), mastery of effortless practice" }
  ],
  
  milestoneEvents: [
    {
      id: 1,
      title: "Sunyatee International Foundation Founded",
      date: "November 2019",
      location: "Siddipet, Telangana, India",
      description: "Establishment of Sunyatee International Foundation (SIF) as a Section 8 Non-Government Company, dedicated to promoting global peace, prosperity, and mindfulness through Sunya meditation.",
      image: "https://sifworld.com/wp-content/uploads/2024/12/optimized-fvru.webp",
      highlights: [
        "Non-profit foundation registered",
        "Dr. Rajesh Savera as Director",
        "Focus on Sunya meditation",
        "Social welfare initiatives"
      ]
    },
    {
      id: 2,
      title: "Pali Translation Project Launch",
      date: "Ongoing since 2019",
      location: "India",
      description: "Major initiative to translate Pali Tipitaka and preserve ancient Buddhist texts. Working with scholars to make early Buddhist teachings accessible to modern practitioners.",
      image: "https://sunyatimes.com/wp-content/uploads/2025/02/Website-3-1-1024x576.png",
      highlights: [
        "Pali Tipitaka translation",
        "Palm leaf sutra printing",
        "Preserving ancient Indian wisdom",
        "Multi-language translations"
      ]
    },
    {
      id: 3,
      title: "DXN Holdings Founded",
      date: "1993-1995",
      location: "Malaysia",
      description: "Dr. Lim Siow Jin founded DXN to share the health benefits of Ganoderma Lucidum with the world. The company pioneered the 'One Dragon' vertical integration model.",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800",
      highlights: [
        "DXN International Thailand (1993)",
        "DXN Holdings Bhd Malaysia (1995)",
        "One Dragon concept introduced",
        "Ganoderma cultivation begins"
      ]
    },
    {
      id: 4,
      title: "DXN Listed on Bursa Malaysia",
      date: "September 30, 2003",
      location: "Bursa Malaysia Main Board",
      description: "DXN Holdings Bhd listed on Bursa Malaysia, marking a significant milestone in the company's growth as a publicly traded wellness enterprise.",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800",
      highlights: [
        "Public listing achieved",
        "Major corporate milestone",
        "Increased transparency",
        "Global expansion funding"
      ]
    },
    {
      id: 5,
      title: "Nagpur Sunya Retreat Center",
      date: "Ongoing",
      location: "Nagaloka, Nagpur, India",
      description: "Regular Sunya meditation retreats conducted at Nagaloka Center in Nagpur, offering structured programs for practitioners at various levels.",
      image: "https://sunyatimes.com/wp-content/uploads/2024/12/Website-12_11zon-860x484.jpg",
      highlights: [
        "3-day residential retreats",
        "Progressive belt system training",
        "Led by trained Sunya Dootas",
        "Regular ongoing programs"
      ]
    },
    {
      id: 6,
      title: "Sunya Online Training Programs",
      date: "2020-Present",
      location: "Global Online",
      description: "Launch of comprehensive online Sunya meditation training, making teachings accessible worldwide. Over 100+ talk shows and interactive sessions conducted.",
      image: "https://sunyatimes.com/wp-content/uploads/2025/02/website-1-12-860x484.png",
      highlights: [
        "100+ online talk shows",
        "Global accessibility",
        "Led by Dr. Lim and Dr. Rajesh",
        "Interactive meditation sessions"
      ]
    }
  ],
  
  retreatLocations: [
    {
      name: "Nagaloka Retreat Centre",
      location: "Nagpur, Maharashtra, India",
      description: "Regular Sunya meditation retreats with structured programs",
      image: "https://sunyatimes.com/wp-content/uploads/2025/07/14.0-420x280.jpeg"
    },
    {
      name: "Sunya Studio Retreat",
      location: "Balewadi, Pune, India",
      description: "2-day retreats for urban practitioners seeking inner silence",
      image: "https://sunyatimes.com/wp-content/uploads/2025/07/5-420x280.png"
    },
    {
      name: "Diamond Sutra Retreat",
      location: "Kerala, India",
      description: "Retreat focused on Diamond Sutra study and meditation practice",
      image: "https://sunyatimes.com/wp-content/uploads/2025/07/9-420x280.png"
    }
  ],
  
  navigation: {
    main: [
      {
        label: "About Dr. Lim",
        path: "/about",
        submenu: [
          { label: "Biography & Journey", path: "/about/biography" },
          { label: "Philosophy & Vision", path: "/about/philosophy" },
          { label: "Awards & Recognition", path: "/about/awards" },
          { label: "Milestones & Events", path: "/about/milestones" },
          { label: "In the Media", path: "/about/media" },
          { label: "Photo Gallery", path: "/about/gallery" }
        ]
      },
      {
        label: "My Talks",
        path: "/talks",
        submenu: [
          { label: "Video Library (Netflix Style)", path: "/video-library" },
          { label: "Sunya Talks", path: "/talks/sunya" },
          { label: "Ganotherapy", path: "/talks/ganotherapy" },
          { label: "Shang Han Lun Series", path: "/talks/shang-han-lun" },
          { label: "Herbology", path: "/talks/herbology" },
          { label: "Herbal Talk", path: "/talks/herbal" },
          { label: "Coffee Talk", path: "/talks/coffee" },
          { label: "Hexageneous Reflexology", path: "/talks/reflexology" }
        ]
      },
      {
        label: "My Articles",
        path: "/articles"
      },
      {
        label: "DXN Legacy",
        path: "/dxn",
        submenu: [
          { label: "The DXN Story", path: "/dxn/story" },
          { label: "Business Philosophy", path: "/dxn/philosophy" },
          { label: "Products & Innovation", path: "/dxn/products" },
          { label: "Global Presence", path: "/dxn/global" },
          { label: "DXN Cyberville", path: "/dxn/cyberville" },
          { label: "Corporate Milestones", path: "/dxn/milestones" },
          { label: "Success Stories", path: "/dxn/success" }
        ]
      },
      {
        label: "Sunya & Sunyatee",
        path: "/sunya",
        submenu: [
          { label: "What is Sunya?", path: "/sunya/what-is" },
          { label: "Sunya Practice Guide", path: "/sunya/practice" },
          { label: "The 7-Belt System", path: "/sunya/belts" },
          { label: "Ethical Foundations", path: "/sunya/ethics" },
          { label: "Sunyatee Foundation", path: "/sunya/foundation" },
          { label: "Retreats & Training", path: "/sunya/retreats" },
          { label: "Online Training", path: "/sunya/online" },
          { label: "Social Welfare", path: "/sunya/welfare" }
        ]
      },
      {
        label: "TCM & Wellness",
        path: "/wellness",
        submenu: [
          { label: "Traditional Chinese Medicine", path: "/wellness/tcm" },
          { label: "Ganotherapy", path: "/wellness/ganotherapy" },
          { label: "Herbal Medicine", path: "/wellness/herbal" }
        ]
      },
      {
        label: "Peace & Humanitarian",
        path: "/peace"
      },
      {
        label: "Resources",
        path: "/resources"
      },
      {
        label: "Contact",
        path: "/contact"
      }
    ]
  },
  
  // Gallery images - AUTHENTIC from sunyatimes.com and official sources
  sunyateeGallery: {
    practitioners: [
      {
        id: 1,
        title: "Nagpur Sunya Retreat Practitioners",
        description: "800 participants at the Nagpur Sunya Retreat under the guidance of Datuk Dr. Lim Siow Jin",
        image: "https://sunyatimes.com/wp-content/uploads/2024/12/Website-12_11zon-860x484.jpg",
        category: "Retreats",
        source: "sunyatimes.com"
      },
      {
        id: 2,
        title: "Group Meditation Session",
        description: "Practitioners during guided meditation at Nagaloka retreat center",
        image: "https://sunyatimes.com/wp-content/uploads/2025/07/14.0-860x484.jpeg",
        category: "Retreats",
        source: "sunyatimes.com"
      },
      {
        id: 3,
        title: "Sunya Studio Retreat Pune",
        description: "2-day retreat at Sunya Studio in Balewadi, Pune",
        image: "https://sunyatimes.com/wp-content/uploads/2025/07/5-860x484.png",
        category: "Retreats",
        source: "sunyatimes.com"
      }
    ],
    gatherings: [
      {
        id: 4,
        title: "Nagpur Retreat 800 Participants",
        description: "One of the largest Sunya gatherings dedicated to mindfulness practice",
        image: "https://sunyatimes.com/wp-content/uploads/2024/12/Website-11_11zon-860x484.jpg",
        category: "Mega Gatherings",
        source: "sunyatimes.com"
      },
      {
        id: 5,
        title: "Diamond Sutra Retreat Kerala",
        description: "Retreat focused on Diamond Sutra study and meditation practice",
        image: "https://sunyatimes.com/wp-content/uploads/2025/07/9-420x280.png",
        category: "Retreats",
        source: "sunyatimes.com"
      },
      {
        id: 6,
        title: "Retreat Meditation Hall",
        description: "Group meditation session in the main hall",
        image: "https://sunyatimes.com/wp-content/uploads/2024/12/Website-10_11zon-860x484.jpg",
        category: "Retreats",
        source: "sunyatimes.com"
      }
    ],
    events: [
      {
        id: 7,
        title: "Nagaloka Retreat Center",
        description: "Regular Sunya meditation retreats with structured programs",
        image: "https://sunyatimes.com/wp-content/uploads/2025/07/14.0-420x280.jpeg",
        category: "Events",
        source: "sunyatimes.com"
      },
      {
        id: 8,
        title: "Pali Translation Project",
        description: "Palm leaf sutra printing and preservation work",
        image: "https://sunyatimes.com/wp-content/uploads/2025/02/Website-3-1-1024x576.png",
        category: "Projects",
        source: "sunyatimes.com"
      },
      {
        id: 9,
        title: "Sunya Online Training",
        description: "Over 100+ online talk shows and interactive sessions",
        image: "https://sunyatimes.com/wp-content/uploads/2025/02/website-1-12-860x484.png",
        category: "Online",
        source: "sunyatimes.com"
      }
    ]
  }
};